// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckboxSelectController from "./checkbox_select_controller"
application.register("checkbox-select", CheckboxSelectController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CompanyJobFilterController from "./company_job_filter_controller"
application.register("company-job-filter", CompanyJobFilterController)

import CompanyModeController from "./company_mode_controller"
application.register("company-mode", CompanyModeController)

import ConsentController from "./consent_controller"
application.register("consent", ConsentController)

import DiagnosticResultController from "./diagnostic_result_controller"
application.register("diagnostic-result", DiagnosticResultController)

import FilterBarController from "./filter_bar_controller"
application.register("filter-bar", FilterBarController)

import InterviewIntakeController from "./interview_intake_controller"
application.register("interview-intake", InterviewIntakeController)

import InterviewSessionController from "./interview_session_controller"
application.register("interview-session", InterviewSessionController)


import ResumeDocumentController from "./resume_document_controller"
application.register("resume-document", ResumeDocumentController)

import ResumeWizardController from "./resume_wizard_controller"
application.register("resume-wizard", ResumeWizardController)

import RoleplayDeviceController from "./roleplay_device_controller"
application.register("roleplay-device", RoleplayDeviceController)

import RoleplayFormController from "./roleplay_form_controller"
application.register("roleplay-form", RoleplayFormController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SubmitProgressController from "./submit_progress_controller"
application.register("submit-progress", SubmitProgressController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import TagSelectController from "./tag_select_controller"
application.register("tag-select", TagSelectController)

import TaskDoneDateController from "./task_done_date_controller"
application.register("task-done-date", TaskDoneDateController)

import TimePickerController from "./time_picker_controller"
application.register("time-picker", TimePickerController)
